import React, { useId } from 'react';
import { Button, Pagination, Modal, message, Select, Image } from 'antd'
import SelectList from '../../common/SelectList';
import Input from '../../common/Input';
import CustomTable from '../../common/Table';
import moment from 'moment';
import CustomModal from '../../common/Modal';
import HRInfo from './HRInfo';  // hr信息
import Refuse from '../../common/Refuse';  //拒绝弹窗

export default class CompanyUser extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			status: -1,
			name: "",
			type: '',
			rechargeVisible: false,
			editData: {}
		}
		this.columns = [
			{
				title: '序号',
				width: 80,
				dataIndex: 'key',
				key: 'key',
				sorter: true,
				align: 'center'
			}, {
				title: 'HR信息',
				dataIndex: 'name',
				key: 'name',
				align: 'left',
				width: 300,
				className: 'pubname',
				render: (_, info) => {
					return (
						<div className='userInfo'>
							<Image src={info.avatar} className='avatar' width={40} height={40} />
							<div className='userNameInfo' onClick={() => {
								this.setState({
									type: 'hr',
									editData: info,
									visible: true,
								})
							}}>
								<p>{info.name}</p>
								<p>{info.job_name}·{info.mobile}</p>
							</div>
						</div>
					);
				}
			}, {
				title: '团队信息',
				dataIndex: 'user_type',
				key: 'user_type',
				align: 'left',
				width: 200,
				className: 'pubname',
				render: (_, info) => {
					return (
						<>
							<p onClick={() => {
								this.setState({
									editData: info,
									type: 'business',
									visible: true,
								})
							}}>{info.company_name}</p>
							<p onClick={() => {
								this.setState({
									editData: info,
									type: 'team',
									visible: true,
								})
							}}>{info.team_name}</p>
						</>
					);
				}
			}, {
				title: '微信号',
				dataIndex: 'wx_no',
				key: 'wx_no',
				align: 'center',

			}, {
				title: '邮箱',
				dataIndex: 'email',
				key: 'email',
				align: 'center'
			}, {
				title: '状态',
				dataIndex: 'status',
				key: 'status',
				align: 'center',
				className: 'cursor',
				render: (status, item) => {
					if (status == 1) {
						return <p onClick={() => {
							Modal.confirm({
								title: "提示",
								content: "是否审核通过?",
								cancelText: "驳回",
								okText: "通过",
								centered: true,
								onCancel: () => {
									// this.refe.setData({
									// 	visible: true,
									// 	id: item.c_uid,
									// 	status: 2,
									// })
									this.refe.setState({
										visible: true,
										id: item.id,
										status: 2,
									})
								},
								onOk: () => {
									this.checkStatus(1, item.id)
								},

							})
						}} className='color2'>待审核</p>
					} else if (status == 2) {
						return <p onClick={() => {

						}} className='color1'>已通过</p>
					} else if (status == 3) {
						return <p className='color3'>已拒绝</p>
					} else {
						return <p className='color4'>账号禁用</p>
					}
				}
			}, {
				title: '申请时间',
				dataIndex: 'atime',
				key: 'atime',
				align: 'center',

			},, {
				title: '审核备注',
				dataIndex: 'remarks',
				key: 'remarks',
				align: 'center',
				render: (remarks) => (
					remarks || "-"
				)
			}, {
				title: '操作',
				dataIndex: 'admin_id',
				key: 'admin_id',
				align: 'center',
				render: (id, item) => {
					return (
						<div className='flexAllCenter pubbtnbox'>
							<p className='color1' onClick={() => {
								this.setState({
									editData: item,
									type: 'hr',
									visible: true,
								})
							}}>查看详情</p>
						</div>
					)
				}
			}
		]
	}
	checkStatus(status, id, remarks) {
		let req = {
			status,
			id,
			remarks,
		}
		global.Ajax.hhtc_request('company/auditApply', req).then(res => {
			if (res.code == 1) {
				message.success(res.msg, 1.2)
				this.refresh()
			} else {
				message.error(res.msg, 1.2)
			}
		})
	}

	refresh() {
		this.tabblelist.onRefresh()
	}
	getList(info, callback) {
		var req = {
			page: info.page,
			size: info.size,
			orderBy: info.orderBy,
			status: this.state.status
		}
		global.Ajax.hhtc_request('company/applyList', req).then(res => {
			callback(res)
		})
	}
	// 删除
	del(data) {
		var url = 'user/userEnable', req = { user_id: data.user_id }
		this.delmask.del(url, req, "确定要" + (data.status == 1 ? "冻结" : "解冻") + "用户吗?")
	}
	onRefresh(info, callback) {
		this.getList(info, callback)
	}
	render() {
		return (
			<React.Fragment>
				<div className='flexCenter'>
					{/* <Input
						placeholder='请输入团队名称、公司名称、HR名称查询'
						className='borderbai'
						style={{ width: 340 }}
						onChange={(e) => {
							this.setState({
								name: e.target.value
							}, () => {
								this.refresh()
							})
						}}
					/> */}
					<Select
						allowClear
						className='pubSelt marginr12 borderbai'
						style={{
							width: 150
						}}
						onChange={(e) => {
							if (e == undefined) {
								e = -1;
							}
							this.setState({
								status: e
							}, () => {
								this.refresh();
							})
						}}
						placeholder="申请状态"
						options={[
							{
								value: 1,
								label: '待审核',
							},
							{
								value: 2,
								label: '已通过',
							},
							{
								value: 3,
								label: '已拒绝',
							},
						]}
					/>
				</div>
				<div className='bgbai'>
					<h2 className='pubTit'>HR申请记录列表</h2>
					<CustomTable
						ref={dom => this.tabblelist = dom}
						columns={this.columns}
						onRefresh={this.onRefresh.bind(this)}  //刷新
						className='pubList'

					/>
				</div>
				{/*
					type=hr  查看hr信息
					type=business  查看企业信息
					type=team  查看团队信息
				 */}
				<CustomModal
					visible={this.state.visible}
					width={388}
					closable={false}
					className='ginfobox'
					onCancel={this.onCancel.bind(this)}
				>
					<HRInfo data={this.state.editData} type={this.state.type} all={this.state.all} onClose={this.onCancel.bind(this)} />
				</CustomModal>
				{/* 拒绝弹窗 */}
				<Refuse
					ref={dom => this.refe = dom}
					type={this.state.type || ''}
					remarks={this.state.remarks || ''}
					onFinish={(req) => {
						if (this.state.type == 'readOnly') {
							this.refe.onCancel()
							return
						}
						this.refe.setState({
							// loading: true,
						}, () => {
							req.status = this.refe.state.status;
							req.id = this.refe.state.id;
							global.Ajax.hhtc_request('company/auditApply', req).then(res => {
								if (res.code == 1) {
									message.success(res.msg, 1.2)
									this.onOk()
								} else {
									message.error(res.msg, 1.2)
								}
								this.refe.setState({
									loading: false,
								}, () => {
									if (res.code == 1) {
										this.refe.onCancel()
									}
								})
							})
						})
					}}
					onCancel={() => {
						this.setState({
							type: '',
							remarks: '',
							visible: false,
							infoData: {}
						})
					}}
				/>
			</React.Fragment>
		)
	}
	onOk() {
		this.refresh()
		this.onCancel()
	}
	onCancel() {
		this.setState({
			visible: false,
			rechargeVisible: false,
			editData: {},
			type: '',
			all: false,
		})
	}
}
